// Phase COLLEGE-PRICING-1 · public page · /college-logistics-pricing
import { useEffect, useState } from "react";
import axios from "axios";
import { CollegePricingPageView } from "../../components/college/CollegePricingView";

const API = process.env.REACT_APP_BACKEND_URL;

export default function CollegeLogisticsPricing() {
  const [data, setData] = useState(null);
  const [err, setErr] = useState("");
  const [etag, setEtag] = useState("");

  const fetchOnce = async (currentEtag) => {
    try {
      const r = await axios.get(`${API}/api/public/college-pricing`, {
        headers: currentEtag ? { "If-None-Match": currentEtag } : {},
        validateStatus: (s) => s === 200 || s === 304,
      });
      if (r.status === 200) {
        setData(r.data);
        const e = r.headers?.etag || r.headers?.ETag || "";
        if (e) setEtag(e);
      }
    } catch (e) {
      setErr(e?.response?.data?.detail || e?.message || "Failed to load");
    }
  };

  useEffect(() => {
    fetchOnce("");
    const id = setInterval(() => fetchOnce(etag), 30_000);
    return () => clearInterval(id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (err) {
    return (
      <div className="max-w-md mx-auto p-8 text-center"
           data-testid="college-pricing-error">
        <div className="text-sm text-rose-700">Couldn't load pricing · {err}</div>
        <button onClick={() => fetchOnce("")}
                className="mt-3 text-xs px-3 py-1.5 rounded-lg bg-[#FF6B00] text-white">
          Retry
        </button>
      </div>
    );
  }
  if (!data) {
    return (
      <div className="max-w-6xl mx-auto p-10 grid grid-cols-1 md:grid-cols-3 gap-5"
           data-testid="college-pricing-loading">
        {[0, 1, 2].map((i) => (
          <div key={i} className="h-72 bg-slate-100 rounded-2xl animate-pulse"/>
        ))}
      </div>
    );
  }
  return (
    <div className="min-h-[100dvh] bg-slate-50">
      <CollegePricingPageView page={data.page} cards={data.cards}/>
      <footer className="text-center text-xs text-slate-400 py-6"
              data-testid="college-pricing-version-id">
        version: {data.version_id}
      </footer>
    </div>
  );
}
